import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import EventManagerHistoryLayer from "../components/EventManagerHistoryLayer";

const EventManagerHistoryPage = () => {
  return (
    <MasterLayout>
      <EventManagerHistoryLayer />
    </MasterLayout>
  );
};

export default EventManagerHistoryPage;
